// các ví hỗ trợ
export const supportWallet = {
  metamask: "Metamask",
  binanceChain: "BinanceChain",
  trustWallet: "TrustWallet",
  dfyWallet: "DFYWallet",
  walletConnect: "walletConnect",
  safePal: "SafePal",
};
